import { Component, OnInit } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Platform, Events } from '@ionic/angular';
import { environment } from '../../../../environments/environment';
import { AccountService } from 'src/app/services/auth/account.service';
import { version } from '../../../../../package.json';
import { LOGO_PATH_FULL } from 'src/app/constants';
const { APP_NAME } = environment;

@Component({ 
  selector: 'app-start',
  templateUrl: './start.page.html',
  styleUrls: ['./start.page.scss'],
})
export class StartPage {

  version = version;
  appName = APP_NAME;

  logoPath = LOGO_PATH_FULL;

  constructor(
    platform: Platform,
    appVersion: AppVersion,
    private accountService: AccountService,
  ) {

    if (platform.is('cordova')) {
      platform.ready()
        .then(() => appVersion.getVersionNumber())
        .then(version => this.version = version)
        .catch(err => console.log('Error in version number', err));
    }
  }

  async enter() {
    await this.accountService.loginMultiplexer();
  }

  async signup() {
    await this.accountService.loginMultiplexer('signup', '/onboarding/tutorial?slide=1');
  }

}
